import React from 'react';

import {DateRangeInput} from 'src/components/input';

import {Group} from '@pb/kit-component-group';
import Label from '@pb/kit-component-label';


type Props = {
    startDate: string | undefined,
    endDate: string | undefined,
    onChangeStartDate: (date: string) => void,
    onChangeEndDate: (date: string) => void,
};

export const PeriodFilter = ({startDate, endDate, onChangeStartDate, onChangeEndDate}: Props) => {
    return (
        <div>
            <Label>Period</Label>
            <Group direction="v">
                <DateRangeInput
                    id="change-log-start-date-picker"
                    width={200}
                    label="Starts"
                    clearable={true}
                    startDate={startDate}
                    endDate={endDate}
                    selectRangeType="start"
                    onChange={onChangeStartDate}
                />
                <DateRangeInput
                    id="change-log-end-date-picker"
                    width={200}
                    label={<>Ends&nbsp;&nbsp;</>}
                    clearable={true}
                    startDate={startDate}
                    endDate={endDate}
                    selectRangeType="end"
                    onChange={onChangeEndDate}
                />
            </Group>
        </div>
    );
};
